import { render, staticRenderFns } from "./Certification-management.vue?vue&type=template&id=283b557a&scoped=true&"
import script from "./Certification-management.vue?vue&type=script&lang=js&"
export * from "./Certification-management.vue?vue&type=script&lang=js&"
import style0 from "./Certification-management.vue?vue&type=style&index=0&id=283b557a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283b557a",
  null
  
)

export default component.exports